export const LANG_TO_LOCALE = {
  de: 'de_DE',
  en: 'en',
  es: 'es_LA',
  fr: 'fr_FR',
  pt: 'pt_PT',
  tr: 'tr_TR',
  it: 'it_IT',
  ja: 'ja_JP',
  pl: 'pl_PL',
} as const;

export const DEFAULT_LOCALE = 'en';
